<template>
  <div
    class="featured-section w-full bg-cover bg-center flex flex-col items-center justify-center h-full relative bg-blue rounded-l-lg"
    :key="key"
  >
    <loader v-if="loading" dark />
    <img
      v-if="bannerType === 'image' && !lockedStatus"
      class="w-full h-full object-cover"
      :src="featuredImage"
      alt=""
    />
    <div
      v-else-if="bannerType === 'video' && !lockedStatus"
      class="featured-video w-full rounded-l-lg"
      v-html="featuredVideoEmbed"
    ></div>
    <audio
      class="w-50 shadow border rounded-full"
      v-else-if="bannerType === 'audio' && !lockedStatus"
      controls
      controlsList="nodownload"
    >
      <source :src="featuredAudio" />
    </audio>

    <div
      v-else
      class="offer-preview shadow-lg w-full h-full locked-post-wrapper flex locked justify-center items-center flex-col btn-radius relative border opacity-100"
    >
      <div class="shadow-lg">
        <div class="w-full h-full shadow-2xl rounded-lg text-grey-800">
          <i class="fa fa-lock" style="width: 45px; height: 45px"></i>
        </div>
      </div>
    </div>

    <div
      v-if="calledFrom == 'post' && !isPreview"
      class="absolute flex right-0 bottom-0 mt-4 mr-2 space-x-1 banner-type-options-wrapper"
      @click="toggleIsElementOptionShow"
    >
      <p
        class="btn cursor-pointer"
        :class="bannerType == 'image' ? 'image-icon' : 'video-icon'"
      ></p>
    </div>

    <div
      v-if="isElementOptionShow && calledFrom == 'post' && !isPreview"
      :class="isElementOptionShow ? 'show-img-vid-dropdown' : 'hidden'"
      class="video-custom-dropdown flex items-center absolute right-0 bottom-0 mr-4 mb-4 z-13"
    >
      <ul class="p-4 show-img-vid-dropdown-wrapper">
        <li class="builder-video-picker relative">
          <video-picker
            :value="{ featuredVideoSrc, featuredVideoEmbed }"
            @selected="updateFeaturedVideoHOC($event.video_embed)"
          ></video-picker>
          <div class="absolute top-0 pointer-events-none flex text-sm py-2">
            <VideoIcon /> <label>Video</label>
          </div>
        </li>
        <li class="relative builder-image-picker">
          <image-picker
            :value="featuredImage"
            @change="updateFeaturedImageHOC"
          ></image-picker>
          <div class="">
            <div class="flex text-sm py-2">
              <ImageIcon /> <label>Image</label>
            </div>
          </div>
        </li>
        <li class="mb-2">
          <div
            @click="openSelectAudioPopup()"
            class="builder-audio-picker relative"
          >
            <div class="flex text-sm py-2">
              <AudioIcon /> <label>Audio</label>
            </div>
          </div>
        </li>
        <li class="pb-2 remove">
          <div class="text-sm text-pink" @click="remove">Remove</div>
        </li>
        <div
          @click="close"
          class="absolute right-3 bottom-2 cursor-pointer text-grey-600"
        >
          X
        </div>
      </ul>
    </div>

    <gd-modal
      v-if="!isPreview"
      class="custom-modal"
      ref="downloadLinkModal"
      name="download-link-modal"
      :title="'Upload Audio'"
      @opened="() => {}"
      @closed="() => {}"
    >
      <div class="p-6">
        <!-- <div class="mb-6">
                  <p class="text-dark text-sm font-semibold mb-2">Title</p>
                  <text-input
                    v-model="fileData.title"
                    placeholder="Title"
                    :validator="$v.fileData.title"
                    attribute="Title"
                  />
                </div> -->
        <div class="mb-6">
          <p class="text-dark text-sm font-semibold mb-2">File</p>
          <gd-dropdown
            v-model="fileData.value"
            placeholder="--Select File--"
            :validator="$v.fileData.value"
            attribute="File"
            :options="filesDropdownOptions"
            size="full"
            class="w-full h-10 custom-selectbox custom-last-selectbox"
          ></gd-dropdown>
          <div
            v-if="$v.fileData.value.$dirty && $v.fileData.value.$invalid"
            class="text-red mt-2"
          >
            Please select a file.
          </div>
        </div>
        <div class="flex flex-row w-full justify-center space-x-4">
          <gd-button
            size="auto"
            class="h-10 modal-btn-width px-4 btn-radius text-base font-semibold border-grey-300"
            @click="closeAddEditPopup()"
            >Cancel</gd-button
          >
          <gd-button
            size="auto"
            primary
            class="h-10 modal-btn-width px-4 btn-radius text-base font-semibold ml-2"
            @click="updateItem(fileData)"
            >Done</gd-button
          >
        </div>
      </div>
    </gd-modal>

    <div class="main-banner-image" v-if="!isPreview">
      <!-- custom-banner-image-overlay -->
      <div class="custom-banner-image-overlay">
        <div
          v-if="bannerType === 'image'"
          @click="showOverlayColorSettings = !showOverlayColorSettings"
        >
          <div class="text-white cursor-pointer text-xl">
            <i class="fas fa-palette"></i>
          </div>
        </div>
        <div
          v-if="showOverlayColorSettings"
          class="w-60 bg-grey-900 text-sm p-6 btn-radius absolute right-0 top-0 mt-7 z-10"
          v-on-click-outside="closeColorPalette"
        >
          <span
            class="cursor-pointer text-white absolute right-0 top-0 mr-2 mt-2"
            @click="showOverlayColorSettings = false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 12 12"
              class="h-3 w-3"
            >
              <path
                data-v-04c5e4a0=""
                fill="#8689A4"
                d="M7.426 5.971l4.278-4.258a1 1 0 000-1.419 1.012 1.012 0 00-1.426 0L5.999 4.552 1.721.294a1.012 1.012 0 00-1.426 0 1 1 0 000 1.42L4.573 5.97.295 10.23a1 1 0 000 1.419 1.012 1.012 0 001.426 0L6 7.39l4.279 4.258a1.012 1.012 0 001.426 0 1 1 0 000-1.42L7.426 5.972z"
              ></path></svg
          ></span>

          <div class="flex justify-between items-center">
            <div class="text-grey-100 image-overlay-text">Image Overlay</div>
            <div class="w-20">
              <color-picker
                :value="this.overlayColor"
                :colors="tailwindConfig.colors"
                @change="updateOverlay"
                :cookies-origin="`groovemember_membership_` + $route.params.id"
                :opacities="50"
              ></color-picker>
            </div>
          </div>
        </div>
      </div>
      <!-- custom-banner-image-overlay end -->

      <!-- common banner -->
      <div
        class="flex items-center absolute right-0 bottom-0 mr-4 mb-4 z-13"
        v-if="!isPreview"
      >
        <div
          class="builder-image-picker img-picker relative"
          v-if="bannerType === 'image'"
          :key="bannerType"
        >
          <image-picker
            :value="featuredImage"
            @change="updateFeaturedImageHOC"
          ></image-picker>
          <i class="fa fas fa-camera" aria-hidden="true"></i>
        </div>
        <div
          class="builder-video-picker relative"
          v-if="bannerType === 'video'"
          :key="bannerType"
        >
          <video-picker
            :value="{ featuredVideoSrc, featuredVideoEmbed }"
            @selected="updateFeaturedVideoHOC($event.video_embed)"
          ></video-picker>
          <div class="video flex">
            <i class="fa fas fa-video" aria-hidden="true"></i>
          </div>
        </div>
        <div
          class="builder-audio-picker relative"
          v-if="bannerType === 'audio'"
          :key="bannerType"
        >
          <!-- <span>audio picker</span> -->
          <div class="audio flex">
            <i class="fa fas fa-audio" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tailwindConfig from '@groovepages/gp-page-ui-kit/tailwind';
import ImagePicker from '@groovepages/gd-ui-kit/components/ImagePickerModal';
import VideoPicker from '@groovepages/gd-ui-kit/components/video-library/VideoLibrary';
import GdCustomRadio from '@groovepages/gd-ui-kit/components/GdCustomRadio';
import ImageIcon from '../../../../../assets/images/icons/imageIcon.svg';
import VideoIcon from '../../../../../assets/images/icons/videoIcon.svg';
import AudioIcon from '../../../../../assets/images/icons/videoIcon.svg';
import { directive as onClickOutside } from 'vue-on-click-outside';
const fileIdMustBeGtZero = (value) => JSON.parse(value).id > 0;
import { required, minValue } from 'vuelidate/lib/validators';
import Loader from '@groovepages/gd-ui-kit/components/Loader';

export default {
  name: 'Avatar',
  directives: {
    onClickOutside,
  },
  data() {
    return {
      key: 0,
      loading: false,
      isElementOptionShow: false,
      showOverlayColorSettings: false,
      tailwindConfig,
      fileData: {
        title: '',
        value: {
          id: -1,
        },
        description: '',
      },
    };
  },
  components: {
    GdCustomRadio,
    ImagePicker,
    VideoPicker,
    ImageIcon,
    VideoIcon,
    AudioIcon,
    Loader,
  },
  computed: {
    getOverlayColor() {
      return this.overlayColor.replace('rbga', 'rgba');
    },
    bannerType: {
      get() {
        if (this.bannerSettings.hasOwnProperty('banner_type')) {
          return this.bannerSettings.banner_type;
        }

        return 'image';
      },
      set(value) {
        this.updateType(value);
      },
    },
    filesDropdownOptions() {
      return this.files.map((file) => {
        return { text: file.name, value: JSON.stringify(file) };
      });
    },
  },
  props: {
    //value: {},
    files: {
      type: Array,
      default: () => [],
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    calledFrom: {
      type: String,
      default: () => {
        return 'welcome';
      },
    },
    featuredImage: {
      default: () => {
        return '';
      },
    },
    featuredVideoSrc: {
      default: () => {
        return '';
      },
    },
    featuredVideoEmbed: {
      default: () => {
        return '';
      },
    },
    featuredAudio: {
      default: () => {
        return '';
      },
    },
    overlayColor: {},
    updateFeaturedImage: {
      type: Function,
      default: () => {},
    },
    updateFeaturedVideo: {
      type: Function,
      default: () => {},
    },
    updateFeaturedAudio: {
      type: Function,
      default: () => {},
    },
    updateOverlay: {
      type: Function,
      default: () => {},
    },
    updateType: {
      type: Function,
      default: () => {},
    },
    bannerSettings: {
      required: true,
    },
    lockedStatus: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    fileData: {
      title: {
        //   required,
      },
      value: {
        required,
        fileIdMustBeGtZero,
      },
      description: {
        //   required,
      },
    },
  },
  methods: {
    closeColorPalette() {
      this.showOverlayColorSettings = false;
    },
    toggleIsElementOptionShow() {
      this.isElementOptionShow = !this.isElementOptionShow;
    },
    openImageVideoPicker(value) {
      this.updateType(value);
      this.key += 1;
    },
    remove() {
      this.updateFeaturedImage('');
      this.updateFeaturedVideo('');
      this.updateFeaturedAudio('');
      this.key = 0;
    },
    close() {
      this.isElementOptionShow = !this.isElementOptionShow;
    },
    openSelectAudioPopup() {
      this.resetFilesData();
      this.$refs.downloadLinkModal.open();
    },
    closeAddEditPopup() {
      this.resetFilesData();
      this.$refs.downloadLinkModal.close();
    },
    updateItem({ value }) {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) {
          throw new Error('Invalid Data');
        }
        this.openImageVideoPicker('audio');
        this.updateFeaturedAudio(JSON.parse(value).public_path);
        this.resetFilesData();
        this.$refs.downloadLinkModal.close();
      } catch (err) {
        console.log({ err });
        /** */
      }
    },
    resetFilesData() {
      this.fileData = {
        title: '',
        value: JSON.stringify({
          id: -1,
        }),
        description: '<p>Some Description</p>',
      };
    },
    updateFeaturedImageHOC(value) {
      this.openImageVideoPicker('image');
      this.loading = true;
      this.updateFeaturedImage(value);

      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    updateFeaturedVideoHOC(value) {
      this.openImageVideoPicker('video');
      this.loading = true;
      this.updateFeaturedVideo(value);

      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
  },
};
</script>
<style lang="scss">
.featured-section {
  #groovemember-content-box groovevideo-widget {
    width: 100% !important;
  }
  #groovemember-content-box
    groovevideo-widget
    [class$='groovevideo-widget-inner-container'] {
    padding-bottom: 56.25% !important;
  }
  height: 469px;
  .banner-type-options {
    label > span {
      display: none;
    }
  }
  .builder-image-picker {
    .edit-icon {
      display: none;
    }
    position: relative;
    .h-20.border-dashed,
    .h-20.border-dashed + .flex-grow,
    .h-20.border-dashed + .flex-grow + .flex {
      display: none;
    }
    & > .flex > button {
      height: 32px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 6px;
      padding: 5px 33px 5px 8px;
      margin: 0;
      span {
        display: none;
      }
      &:before {
        content: 'Edit';
        font-size: 16px;
        font-weight: 600;
        color: #fefefe;
      }
    }
    svg.fa-camera {
      position: absolute;
      right: 8px;
      top: 8px;
      color: #fefefe;
      pointer-events: none;
    }
  }
  .builder-video-picker {
    width: 71px;
    .video-library-wrapper .edit-icon path {
      fill: transparent;
    }
    .video {
      margin: auto;
      left: 0;
      position: absolute;
      top: 0px;
      right: 0;
      pointer-events: none;
      height: 32px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 6px;
      padding: 5px 54px 5px 8px;
      &:before {
        content: 'Edit';
        font-size: 16px;
        font-weight: 600;
        color: #fefefe;
        padding-right: 7px;
      }
      svg.fa-video {
        color: #fefefe;
        position: absolute;
        margin: auto;
        right: 10px;
        top: 0;
        bottom: 0;
      }
    }
  }
  .overlay-slider input.ml-2 {
    border-color: #545671;
    background-color: #292b49;
    color: #fff;
  }
  &.img-picker {
    height: 32px;
    background: hsla(0, 0%, 100%, 0.2);
    border-radius: 6px;
    padding: 5px 33px 5px 8px;
    margin: 0;
    .my-4 {
      margin: 0px;
    }
    button#gp-styleEditor-chooseImage {
      background: transparent;
      color: transparent;
      box-shadow: none;
      border: none;
      width: 100%;
      //font-size: 8px;
      position: absolute;
      top: 0px;
      left: 0px;
      &:hover,
      &:focus {
        background: transparent;
        box-shadow: none;
        border: none;
      }
    }
    &:before {
      content: 'Edit';
      font-size: 16px;
      font-weight: 600;
      color: #fefefe;
    }
  }
  .featured-video {
    height: 469px;
    background-color: #000;
    display: flex;
    align-items: center;
    iframe {
      height: 469px;
      //   border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }
    div {
      width: 700px;
      max-height: 469px;
      //  height: 469px;
      //position: inherit;
    }
  }
}

.z-13 {
  z-index: 13;
}

//tablet/mobile css
.tablet-template {
  .featured-section {
    height: 250px !important;
    .featured-video {
      height: 250px;
      iframe,
      img {
        height: 250px;
        border-radius: 10px;
      }
      div {
        width: 400px;
        max-height: 250px;
        // height: 250px;
        // position: inherit;
      }
    }
    .main-banner-image,
    .banner-type-options-wrapper {
      display: none;
    }
  }
}

.mobile-template {
  .featured-section {
    height: 181px !important;
    .featured-video {
      height: 181px;
      iframe,
      img {
        height: 181px;
        border-radius: 10px;
      }
      div {
        width: 363px;
        max-height: 181px;
        // height: 181px;
        // position: inherit;
      }
    }
    .main-banner-image,
    .banner-type-options-wrapper {
      display: none;
    }
  }
}
@media only screen and (max-width: 992px) {
  .featured-section {
    .featured-video {
      groovevideo-widget {
        width: 100%;
      }
      div {
        width: 100%;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .featured-section {
    height: 250px !important;
    .featured-video {
      height: 250px;
      groovevideo-widget {
        width: 100%;
      }
      iframe,
      img {
        height: 250px;
        border-radius: 10px;
      }
      div {
        width: 100%;
        max-height: 250px;
      }
    }
  }
}
.show-img-vid-dropdown {
  .builder-image-picker {
    padding: 0px;
  }
  label {
    color: #545671;
    padding-left: 10px;
    line-height: 15px;
  }
  .show-img-vid-dropdown-wrapper {
    background-color: #fff;
    width: 100%;
    box-shadow: 10px 25px 40px #0000002e;
    border-radius: 6px;
    width: 226px;
    li {
      &.builder-image-picker:before {
        content: none;
      }
      &.remove {
        border-top: 1px solid#DCDCEA;
        padding-top: 12px;
        cursor: pointer;
      }
    }
    .builder-video-picker {
      width: 100%;
      .video-iframe-edit > .cursor-pointer > svg {
        opacity: 0;
      }
    }
  }
}
.banner-type-options-wrapper {
  bottom: 16px;
  right: 16px;
  p {
    height: 32px;
    width: 114px;
    background: #ffffff57;
    border-radius: 6px;
    &.image-icon {
      position: relative;
      &::after {
        content: '';
        background: url('../../../../../assets/images/icons/camera.png')
          no-repeat;
        width: 25px;
        position: absolute;
        height: 20px;
        right: 6px;
        top: 4px;
      }
      &::before {
        content: 'Add Media';
        font-size: 14px;
        font-weight: 600;
        color: #fefefe;
        position: absolute;
        right: 35px;
        top: 5px;
      }
    }
    &.video-icon {
      position: relative;
      &::after {
        content: '';
        background: url('../../../../../assets/images/icons/video-camera.png')
          no-repeat;
        width: 23px;
        position: absolute;
        height: 20px;
        right: 6px;
        top: 5px;
      }
      &::before {
        content: 'Add Media';
        font-size: 14px;
        font-weight: 600;
        color: #fefefe;
        position: absolute;
        right: 35px;
        top: 5px;
      }
    }
  }
}
</style>
